import { PageHeader, Section } from "@/components/site/PageChrome";
import { PlayCircle } from "lucide-react";

const categories = [
  { title: "Development", tones: ["#FFE4CC", "#FFD8A8", "#FFC078"] },
  { title: "Launch Day", tones: ["#FFEDD5", "#FED7AA", "#FDBA74"] },
  { title: "Marketing Campaigns", tones: ["#FFE4CC", "#FFC078", "#FFD8A8"] },
  { title: "Community Events", tones: ["#FED7AA", "#FFEDD5", "#FDBA74"] },
  { title: "Onboarding Drives", tones: ["#FFD8A8", "#FFE4CC", "#FFC078"] },
  { title: "Office & Team", tones: ["#FDBA74", "#FED7AA", "#FFEDD5"] },
];

export default function GalleryPage() {
  return (
    <>
      <PageHeader
        eyebrow="Gallery"
        title="Moments that made Time2Cash."
        subtitle="From late-night builds to launch celebrations and community events — a visual journey. Real photos & videos coming soon."
      />

      {categories.map((cat, idx) => (
        <Section key={cat.title} className={idx % 2 === 1 ? "bg-[#FFF9F5]" : ""}>
          <div className="flex items-center justify-between">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1A1918]">{cat.title}</h2>
            <span className="text-xs text-[#78716C]">Coming soon</span>
          </div>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[...cat.tones, cat.tones[0]].map((c, i) => (
              <div
                key={i}
                className="aspect-[4/3] rounded-2xl flex items-center justify-center relative overflow-hidden"
                style={{ background: c }}
              >
                {i === 1 && <PlayCircle className="w-10 h-10 text-white/80" />}
              </div>
            ))}
          </div>
        </Section>
      ))}
    </>
  );
}
